import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/division/importer/divisionImporterActions';

export default importerReducers(actions);
